import { cn } from '../utilities.ts'
import { Link, useLocation } from 'react-router-dom'
import {
  PrivilegeCode,
  useUserPrivileges,
} from '../../../hook/useUserPrivileges.tsx'

export type Tab = {
  name: string
  isDisabled?: boolean
  href: string
  privilege?: PrivilegeCode
}

export default function SimpleNavTabs({ tabs }: { tabs: Tab[] }) {
  const location = useLocation()

  const privileges = useUserPrivileges()

  return (
    <div className="sm:block mb-6">
      <div className="border-b border-gray-200">
        <nav aria-label="Tabs" className="-mb-px flex space-x-8">
          {tabs.map((tab) => {
            const isAccessible =
              !tab.privilege || privileges.user?.[tab.privilege]

            const linkUrl = tab.isDisabled ? '#' : tab.href

            if (!isAccessible) return null

            return (
              <Link
                key={tab.name}
                aria-disabled={tab.isDisabled}
                to={linkUrl}
                onClick={(e) => {
                  if (tab.isDisabled) {
                    e.preventDefault()
                  }
                }}
                aria-current={
                  location.pathname === tab.href ? 'page' : undefined
                }
                className={cn(
                  'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium',
                  {
                    'border-primary-500 text-primary-600':
                      location.pathname === tab.href && !tab.isDisabled,
                    'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700':
                      location.pathname !== tab.href && !tab.isDisabled,
                    'border-transparent text-gray-400 cursor-not-allowed':
                      tab.isDisabled,
                  }
                )}
              >
                {tab.name}
              </Link>
            )
          })}
        </nav>
      </div>
    </div>
  )
}
